// 後端業務錯誤碼 -> 提示文案（繁體中文）
// code 為鍵，val 為提示詞；{0}、{1} 為位置佔位符，由 t(key, args) 填充
export default {
  error_code: {
    // 預約
    '1001001': '狀態不匹配',
    '1001002': '禁止修改預約',
    '1001003': '沒有找到預約信息',
    '1001004': '到診不可用',
    '1001005': '已存在預約',
    '1001006': '號源不足',
    '1001007': '禁止預約',
    '1001008': '禁止回退',
    '1001009': '沒有找到患者',
    '1001010': '接口使用方式錯誤',
    '1001011': '沒有找到預約信息【{0}】',
    '1001012': '非當天，禁止重新配藥',
    // 優惠券
    '1002001': '優惠券不支持類型：{0}',
    '1002002': '優惠券名稱重複',
    '1002003': '非用戶券不支持發放',
    '1002004': '不可使用',
    '1002005': '不支持類型',
    '1002006': '已過期',
    '1002007': '不可修改',
    '1002008': '不可刪除',
    '1002009': '存在未使用的優惠券',
    // 藥品
    '1003001': '禁止保存',
    '1003002': '重複籤收藥品',
    '1003003': '條碼不存在',
    '1003004': '藥品已過期',
    '1003005': '庫存不足',
    '1003006': '藥品已變更',
    '1003007': '沒有數據',
    '1003008': '規格不存在',
    '1003009': '金額過大，請核實或分單',
    '1003010': '組織字典映射未就緒，等待 InitOrgDict 完成',
    '1003011': '編碼重複',
    '1003012': '編碼不能重複',
    '1003013': '條碼已存在',
    '1003014': '二維碼已存在',
    '1003015': '藥品已下架',
    '1003016': '藥品已過期',
    '1003017': '藥品不存在或已停用',
    '1003018': '藥品發生變更，請重新添加',
    // 支付
    '1004001': '支付出錯',
    '1004002': '下單失敗',
    '1004003': '無可用付款單',
    '1004004': '已存在退款單',
    '1004005': '退款失敗',
    '1004006': '不支持退款',
    '1004007': '狀態不匹配',
    '1004008': '付款金額有誤',
    '1004009': '收費金額有誤',
    '1004010': '支付方式不可用',
    '1004011': '余額不足',
    '1004012': '訂單發生變更',
    '1004013': '存在未收費項',
    '1004014': '關聯預約不存在或已失效',
    '1004015': '診治未完成，請稍後刷新重試',
    '1004016': '找不到下單的商品信息',
    '1004017': '商品發生變更',
    '1004018': '該收費項已存在',
    '1004019': '收費項【{0}】配置有誤',
    '1004020': 'SourceId不能爲空',
    '1004021': '收費項【{0}】沒有配置濃縮藥/飲片收費規則',
    '1004022': '【{0}】單據有誤',
    '1004023': '【{0}】單據有誤,項目不存在',
    '1004024': '單據變更，請重新發起支付',
    '1004025': '單據變更，請核實單據狀態',
    '1004026': '支付中,禁止退款',
    '1004027': '已存在退款，請稍後重試',
    '1004028': '【{0}】商品已下架',
    '1004029': '【{0}】套票不可用',
    '1004030': '項目【{0}】未收費',
    // 產品
    '1005001': '已存在條碼',
    '1005002': '庫存不足',
    '1005003': '未啓用',
    '1005006': '系統繁忙，請稍後重試',
    '1005007': '產品已下架',
    '1005008': '商品已過期',
    // 號源
    '1006001': '沒有號源',
    // 工作人員
    '1007001': '不存在該工作人員',
    '1007002': '人員已停用',
    '1007003': '人員已存在',
    // 盤點
    '1008001': '盤點單不存在',
    '1008002': '藥品規格不存在：{0}',
    '1008003': '當前狀態不允許刪除明細',
    '1008004': '盤點明細不能爲空',
    // 庫存調整
    '1009001': '當前狀態不允許編輯',
    '1009002': '差異不能爲0',
    '1009003': '藥品規格不存在',
    '1009004': '【{0}】庫存不足，當前庫存：{1}',
    '1009005': '禁止刪除',
    '1009006': '調整明細不能爲空',
    // 套票
    '1010001': '已使用禁止刪除',
    '1010002': '套票項目不能爲空',
    '1010003': '重複項目【{0}】',
    // 其他
    '1011001': '禁止編輯',
    '1012001': '名稱重複',
    // 診所
    '2001001': '編碼已存在',
    '2001002': '編碼不可用',
    '2001003': '找不到該診所',
    '2001004': '診所不可用',
    '2001005': '參數有誤',
    '2001006': '前綴不能重複',
    '2001007': '生成天數不能小於1天',
    '2001008': '間隔時間不能小於10分鍾',
    // 組織
    '2002001': '編碼已存在',
    '2002002': '新建組織時管理員賬號和密碼不能爲空',
    '2002003': '組織不存在',
    '2002004': '無操作權限',
    '2002005': '手機號爲空',
    '2002006': '驗證碼有誤',
    // 密鑰
    '2003001': '密鑰不可用',
    '2003002': '密鑰已過期',
    // 人員
    '2004001': '人員不存在',
    '2004002': '人員不可用',
    '2004003': '人員已存在',
    '2004004': '存在數據，禁止刪除',
    '2004005': '存在預約禁止刪除',
    // 角色
    '2005001': '角色不存在',
    '2005006': '請聯系管理員進行操作！',
    // 用戶
    '2006001': '用戶不存在',
    '2006002': '用戶不可用',
    '2006003': '組織用戶數已達上限',
    '2006004': '禁止啓用員工',
    '2006007': '組織編碼不能爲空',
    '2006008': '賬號已存在',
    // 標籤
    '2007001': '標籤已存在',
    // 患者
    '2008001': '賬號或密碼錯誤',
    '2008002': '密碼錯誤',
    '2008003': '證件已存在',
    '2008004': '姓名手機已存在',
    '2008005': '賬號已存在',
    '2008006': '人員已存在',
    '2008007': '未找到用戶',
    '2008008': '手機號不匹配',
    '2008009': '原密碼不匹配',
    // 登錄
    '2009001': '余額不足',
    '2009002': '域名有誤',
    '2009003': '診所不可用',
    '2009004': '診所不存在',
    '2009005': '組織已停用，禁止登錄',
    '2009006': '用戶不存在',
    '2009007': '用戶不可用',
    '2009008': '禁止登錄！未設置初始密碼，請聯系管理員',
    '2009009': '密碼有誤，請重新輸入',
    '2009010': '不屬於該診所人員，禁止登錄',
    '2009011': '禁止登錄！用戶尚未設置密碼，請聯系管理員',
    '2009012': '余額不足',
    // 醫健通
    '2010001': '預約不存在',
    '2010002': '醫師和患者均未設置醫健通ID',
    '2010003': '醫師未設置醫健通ID',
    '2010004': '患者未設置醫健通ID',
    '2010005': '醫健通ID有誤，請核實',
    // 轉介碼
    '2011001': '轉介碼已存在',
    '2011002': '轉介碼已被患者使用，無法刪除',
    // 診治
    '3001001': '禁止修改',
    '3001002': '藥品【{0}】沒有設定售價',
    '3001003': '禁止重配',
    '3001004': '狀態發生變更',
    '3001005': '禁止重新配藥',
    '3001006': '化驗單不存在',
    '3001007': '項目名稱不能爲空',
    '3001008': '【{0}】項目不存在',
    '3001009': '【{0}】項目已禁用',
    '3001010': '【{0}】處方小項有誤',
    '3001011': '味數不一致',
    '3001012': '超過重配時限',
    '3001013': '超過重配劑數',
    '3001014': '請核實單據是否被撤回修改',
    '3001015': '配藥單已配藥，請勿重複操作',
    '3001016': '配藥單項不存在',
    '3001017': '配藥單項已配藥，請勿重複操作',
    // 藥品規格
    '4001001': '存在規格，禁止刪除',
    // 驗證碼
    '5001001': '達到最大數量',
    '5001002': '稍後重試',
    '5001003': '模板未啓用',
    // 通用
    '9901001': '禁止訪問',
    '9901002': '服務出錯',
    '9901003': '參數有誤',
    '9901004': '數據異常',
    '9901005': '數據處理中',
    '9901006': '讀取配置失敗',
    '9901007': '操作有誤',
    '9901008': '禁止編輯',
    '9901009': '禁止刪除',
    '9901010': '數據重複',
    '9901011': '狀態已發生變化',
    '9901012': '沒有權限查詢',
    '9901013': '項目不存在',
    '9902001': '登錄信息有誤,請重新登錄',
    '9902002': '【RedisConfig】爲空',
    '9902003': '文件有誤',
  },
}
